import React, { useState } from 'react';
import Modal from '@/common/components/Modal/index';
import styles from '@/common/containers/Modals/ConfirmModal/styles.less';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

const COLORS = {
  create: 'primary',
  delete: 'error',
};
const ConfirmModal = ({
  children,
  title,
  description = '',
  cancelText,
  confirmText,
  type = 'create',
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [callback, setCallback] = useState(null);
  const resolvedTitle = title || t('Are u sure?');
  const resolvedCancelText = cancelText || t('cancel');
  const resolvedConfirmText = confirmText || t('confirm');

  const show = (callback) => (event) => {
    event.preventDefault();
    setOpen(true);
    event = {
      ...event,
      target: { ...event.target, value: event.target.value },
    };
    setCallback({
      run: () => callback(event),
    });
  };

  const hide = () => {
    setCallback(null);
    setOpen(false);
  };

  const confirm = () => {
    callback.run();
    hide();
  };
  return (
    <>
      {children(show)}
      <Modal
        className={styles.modal}
        overlayClassname={styles.modalOverlay}
        open={open}
        overlay
      >
        <div className={styles.modalTitle}>
          <h4>{resolvedTitle}</h4>
        </div>
        <p className={styles.modalDescription}>{description}</p>
        <div className={styles.modalBtns}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={hide}
            data-testid="confirmModal-cancel"
          >
            {resolvedCancelText}
          </Button>
          <Button
            variant="contained"
            color={COLORS[type]}
            onClick={confirm}
            data-testid="confirmModal-confirm"
          >
            {resolvedConfirmText}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ConfirmModal;
